import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as pageRoutes from "../../pageRoutes";
import { isThisFeatureAllowed } from "../common/common";
import { checkSessionStatus } from "../../utils/loginSessionOperations";
import { getLocalStorageValue } from "../../utils/localStorageOperations";
import { MATCH_COVERAGE, SUGGESTIONS } from "../common/constants";
import config from "../../config/config.js";

const Home = (props) => {
  const navigate = useNavigate();
  const defaultPageConfg = {
    "pricecomparison": pageRoutes.priceComparisonReportsPage,
    "pricereview": pageRoutes.priceReviewPage,
    "mapviolationreports" : pageRoutes.mapviolationReportsPage
  };

  useEffect(() => {
    const passthrough = JSON.parse(getLocalStorageValue("passThrough"));
    const idToken = getLocalStorageValue("id_token");
    if (!idToken) {
      localStorage.clear();
      if (passthrough) {
          window.location.href = config.pmtEndPoint;
      } else {
          navigate(pageRoutes.loginPage);
      }
    }
    localStorage.removeItem('checkSessionStatus');
    checkSessionStatus(idToken).then((value) => {
      if (value) {
        let modulesAccess = localStorage.getItem("modules")?.split(",") || [];
        let defaultLandingPageString = localStorage.getItem("defaultLandingPage");
        if (defaultLandingPageString && defaultLandingPageString.toLowerCase() in defaultPageConfg) {
          navigate(defaultPageConfg[defaultLandingPageString.toLowerCase()]);
        } else if (modulesAccess.includes("Assortment")) {
          if(isThisFeatureAllowed(SUGGESTIONS)){
            navigate(pageRoutes.dashboardPricingPage);
          } else {
            navigate(pageRoutes.dashboardPage);
          }
        } else {
          console.log('modulesAccess', modulesAccess);
          if (modulesAccess.length == 1 && modulesAccess.includes("Reports") && isThisFeatureAllowed(MATCH_COVERAGE)) {
            navigate(pageRoutes.matchCoveragePage);
          } else {
            navigate(pageRoutes.dashboardPricingPage);
          }
        }
      }
    });
  }, [navigate]);

  return (<>
    <div className="page-container-default background-grey">
      <div className="custom-container border" >
        <div className="p-4 bg-white pt-2">
            <div className="m-5 p-5 text-center">
              <h3>Please wait, processing current Session!</h3>
            </div>
          </div>
      </div>
    </div>
  </>);
};

export default Home;